// extracted by mini-css-extract-plugin
module.exports = {"unauthorised":"Unauthorised_unauthorised__pR9W_","header_background":"Unauthorised_header_background__mwES_"};